/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const USER_ACCOUNT_FEATURE = 'userAccount';
export const USER_ACCOUNT_CORE_FEATURE = 'userAccountCore';
